interface RingProps {
  value: number
}

export function Ring({value}: RingProps) {
  const pct = Math.max(0, Math.min(100, value))
  const dash = 2 * Math.PI * 42
  const filled = (pct / 100) * dash

  return (
    <svg viewBox="0 0 100 100" className="w-16 h-16">
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#ff80ab" />
          <stop offset="100%" stopColor="#ff5722" />
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="42" fill="none" stroke="#1a2236" strokeWidth="9" />
      <circle
        cx="50"
        cy="50"
        r="42"
        fill="none"
        stroke="url(#g)"
        strokeWidth="9"
        strokeDasharray={`${filled} ${dash}`}
        strokeLinecap="round"
        transform="rotate(-90 50 50)"
      />
      <circle cx="50" cy="50" r="32" fill="#0f1524" />
      <text x="50" y="54" textAnchor="middle" className="fill-white text-[14px] font-semibold">
        {value}
      </text>
    </svg>
  )
}
